import React, { ReactNode } from 'react'
import './styles.scss'

interface PromptPillProps {
  children: ReactNode
  onClick?: () => void
}

const PromptPill = ({ children, onClick }: PromptPillProps): JSX.Element => {
  return (
    <button
      type='button'
      className='PromptPill'
      onClick={onClick}
      tabIndex={0}
      aria-label={typeof children === 'string' ? children : undefined}
    >
      {children}
    </button>
  )
}

export default PromptPill
